import { useState, useCallback } from 'react';
const useFiltersToggle = (initialAreFiltersExpanded = false) => {
    const [areFiltersExpanded, setFiltersExpanded] = useState(initialAreFiltersExpanded);
    const toggleFiltersExpansion = useCallback(() => {
        setFiltersExpanded((areFiltersExpanded) => !areFiltersExpanded);
    }, []);
    return [areFiltersExpanded, toggleFiltersExpansion];
};
export default useFiltersToggle;
